import { proxy } from "valtio";
import { ConversionRuleEntity } from "@models/conversionRuleSchema.model";

interface ConversionRuleState {
  organizationId: number | null;
  entities: ConversionRuleEntity[];
  isLoadingEntities: boolean;
  loadError: string | null;
}

export const conversionRuleStore = proxy<ConversionRuleState>({
  organizationId: null,
  entities: [],
  isLoadingEntities: false,
  loadError: null,
});
